import React from "react";

const RequiredIcon = () => {
  return <i className="fa fa-asterisk required ms-1" aria-hidden="true"></i>;
};

export default RequiredIcon;
